import { useRef, useState } from "react";

const INITIAL_POSITION = { x: 0, y: 0 };
export const useMedia = () => {

    const mediaRef = useRef<HTMLImageElement>(null);
    const startPosRef = useRef(INITIAL_POSITION);

    const [scale, setScale] = useState(1); // 1 = pas zoomé
    const [position, setPosition] = useState(INITIAL_POSITION);
    const [isZoomed, setIsZoomed] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = (event: React.MouseEvent) => {
        if (!isZoomed) return;
        setIsDragging(true);
        startPosRef.current = {
            x: event.clientX - position.x,
            y: event.clientY - position.y
        };
    };

    const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max));

    const toggleZoom = () => {

        setIsZoomed((zoomed) => {
            if (!zoomed) setPosition({ x: 0, y: 0 });
            return !zoomed;
        });
        setScale(2);
    };

    const handleMouseMove = (event: React.MouseEvent) => {
        if (!isZoomed || !isDragging) return;

        const media = mediaRef.current;
        if (!media) return;

        const scale = 2;
        const naturalWidth = media.naturalWidth;
        const naturalHeight = media.naturalHeight;

        // Si l'image n'est pas encore chargée correctement
        if (!naturalWidth || !naturalHeight) return;

        const rawX = event.clientX - startPosRef.current.x;
        const rawY = event.clientY - startPosRef.current.y;

        const zoomedWidth = naturalWidth * scale;
        const zoomedHeight = naturalHeight * scale;

        const containerWidth = window.innerWidth;
        const containerHeight = window.innerHeight;

        const maxOffsetX = Math.max(0, (zoomedWidth - containerWidth) / 2.84);
        const maxOffsetY = Math.max(0, (zoomedHeight - containerHeight) / 4.25);

        const clampedX = clamp(rawX, -maxOffsetX, maxOffsetX);
        const clampedY = clamp(rawY, -maxOffsetY, maxOffsetY);

        setPosition({ x: clampedX, y: clampedY });
    };

    const onWheel = (event: React.WheelEvent) => {
        
        if (event.ctrlKey) return; // éviter le zoom système

        const delta = event.deltaY < 0 ? 0.1 : -0.1; // scroll up = zoom in
        setScale((prev) => clamp(prev + delta, 1, 3));

        const activateZoom = scale + delta > 1;
        setIsZoomed(activateZoom);

        if (!activateZoom) {
            setPosition({ x: 0, y: 0 });
        }
    }

    return {
        scale,
        position,
        isDragging,
        startPosRef,
        isZoomed,
        mediaRef,
        handleMouseUp: () => isDragging && setIsDragging(false),
        handleMouseDown,
        handleMouseMove,
        onWheel,
        toggleZoom
    }
}